define('fukit/view/common/pageable.segmented.table.view',['require','exports','module','underscore','uikit/uikit','./segmented.table.view','./pagination.view'],function(require, exports, module) {
  //prettier-ignore
  var _                  = require('underscore'),
      UIKit              = require('uikit/uikit'),
      SegmentedTableView = require('./segmented.table.view'),
      PaginationView     = require('./pagination.view');

  var tableBindings = {
    collection: 'collection',
    model: 'model',
  };
  var ignoreBindingKeys = ['columns', 'tableView', 'paginationView'];
  _.each(SegmentedTableView.prototype.options, function(value, key) {
    tableBindings[key] = key;
  });

  var PageableSegmentedTableView = UIKit.ItemView.extend({
    template: function() {
      return '<ui name="tableView" /><ui name="paginationView" />';
    },

    options: _.extend({}, SegmentedTableView.prototype.options, {
      bottomAttached: false,
    }),

    internalViewOptions: {
      tableView: function() {
        return _.extend({}, _.pick(this.options, _.keys(tableBindings)), {
          type: SegmentedTableView,
        });
      },
      paginationView: function() {
        var collection = this.collection;
        return {
          type: PaginationView,
          model: (collection ? collection.paginate : null) || new Backbone.Model(),
        };
      },
    },

    internalViewBindings: {
      tableView: _.omit(tableBindings, ignoreBindingKeys),
    },

    onInjectedTableView: function(view) {
      this.listenTo(view, 'all', function(evName, table, row) {
        // proxy row events up
        if (evName.indexOf('row') === 0) {
          this.trigger.apply(this, arguments);
        }
      });
    },

    updateAttributes: function() {
      if (this.getBoolOption('bottomAttached')) {
        this.tableView.attached = 'bottom';
        this.tableView.$el.css('border-top', '0');
      } else {
        this.tableView.attached = null;
        this.tableView.$el.css('border-top', '');
      }
    },
  });

  module.exports = PageableSegmentedTableView;
});

